import { useEffect, useState } from "react";
import { columns, type ColumnItem } from "@/mocks/columns";
import SectionHeading from "./SectionHeading";

export default function Columns() {
  const [active, setActive] = useState<ColumnItem | null>(null);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = active ? "hidden" : prev;
    return () => {
      document.body.style.overflow = prev;
    };
  }, [active]);

  return (
    <section id="columns" className="py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="吃瓜专栏"
          title="除了追进展，也教你聪明地吃"
          description="编辑部与作者不定期更新的思考类内容：讲时间线怎么做、信息怎么辨真伪，也聊聊热点为何总在反转。点开任一篇文章即可全文阅读。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {columns.map((col, i) => (
            <button
              key={col.id}
              type="button"
              onClick={() => setActive(col)}
              className={`group flex flex-col justify-between rounded-2xl border border-background-200 bg-background-50 p-6 text-left transition-all hover:-translate-y-0.5 hover:border-accent-300 md:p-7 ${
                i === 1 ? "bg-accent-50/60" : ""
              }`}
              aria-label={`阅读专栏：${col.title}`}
            >
              <div>
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-2.5 py-1 font-semibold text-primary-700">
                    {col.category}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {col.date}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" />
                    约 {col.readMin} 分钟
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {col.views}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-700 md:text-xl">
                  {col.title}
                </h3>
                <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">{col.excerpt}</p>
              </div>

              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                阅读全文
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </button>
          ))}
        </div>
      </div>

      {active ? (
        <div className="fixed inset-0 z-[80] flex items-end justify-center p-0 sm:items-center sm:p-6" role="dialog" aria-modal="true" aria-label="阅读专栏">
          <div className="absolute inset-0 bg-foreground-950/40" onClick={() => setActive(null)} />
          <div className="relative flex max-h-[92vh] w-full max-w-2xl flex-col overflow-hidden rounded-t-2xl bg-background-50 sm:rounded-2xl">
            <div className="flex items-start justify-between gap-4 border-b border-background-200 p-5 md:p-6">
              <div>
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-primary-100 px-2.5 py-1 font-semibold text-primary-700">{active.category}</span>
                  <span>{active.date} · 约 {active.readMin} 分钟 · {active.views} 人已读</span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-900 md:text-2xl">
                  {active.title}
                </h3>
              </div>
              <button
                type="button"
                onClick={() => setActive(null)}
                aria-label="关闭阅读"
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:bg-background-100"
              >
                <i className="ri-close-line text-xl" />
              </button>
            </div>
            <div className="overflow-y-auto p-5 md:p-7">
              <p className="text-sm leading-relaxed text-foreground-700">{active.body[0]}</p>
              {active.body.slice(1).map((p, idx) => (
                <p key={idx} className="mt-4 text-sm leading-relaxed text-foreground-700">
                  {p}
                </p>
              ))}
              <div className="mt-6 flex items-center gap-3 rounded-xl bg-background-100 px-4 py-3">
                <i className="ri-chat-smile-3-line text-primary-600" />
                <p className="text-xs leading-relaxed text-foreground-600">
                  本文为编辑部观点分享，欢迎在阅读后留言交流。你在追瓜时踩过哪些坑？我们很想知道。
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
}